<script setup lang="ts">
import { withDefaults, onMounted, ref, onUnmounted, onUpdated } from 'vue'

// @ts-ignore
import Scale from '../assets/hb1ac.svg?skipsvgo'

const props = withDefaults(
  defineProps<{
    value?: number
  }>(),
  {
    value: 0
  }
)

const OFFSET = 6

const svg = ref()

const cursor = ref()
const text = ref()

const sizeGreen = ref(0)
const sizeYellow = ref(0)
const sizeRed = ref(0)

const updateCursor = () => {
  const valueIsGreen = props.value < 5.7
  const valueIsYellow = props.value >= 5.7 && props.value <= 6.5
  const valueIsRed = props.value > 6.5

  let min = 0
  let max = 0
  let pxMax = 0
  let pxMin = 0

  if (valueIsGreen) {
    min = 0
    max = 5.7
    pxMin = 0
    pxMax = sizeGreen.value
  } else if (valueIsYellow) {
    min = 5.7
    max = 6.5
    pxMin = sizeGreen.value + OFFSET / 3
    pxMax = sizeYellow.value - OFFSET / 2
  } else if (valueIsRed) {
    min = 6.5
    max = 6.5 * 2
    pxMin = sizeGreen.value + sizeYellow.value + OFFSET / 3
    pxMax = sizeRed.value - OFFSET * 2
  }

  const value = Math.max(0, Math.min(props.value, 6.5 * 2))
  const percent = ((value - min) * 100) / (max - min)
  const pxValue = (percent * pxMax) / 100

  const translateBy = pxMin + pxValue

  text.value.textContent = `${props.value.toString()}%`
  cursor.value.style.transform = `translateX(${translateBy}px)`
}

onMounted(() => {
  const el = svg.value.$el as SVGElement

  cursor.value = el.querySelector('#cursor') as SVGGElement
  text.value = cursor.value.querySelector('text') as SVGTextElement

  sizeGreen.value = (el.querySelector('#noDiabetes') as SVGPathElement).getBBox().width - OFFSET // there is some offset on the left side
  sizeYellow.value = (el.querySelector('#preDiabetes') as SVGRectElement).getBBox().width
  sizeRed.value = (el.querySelector('#diabetes') as SVGPathElement).getBBox().width

  cursor.value.style.transition = 'transform 1s ease-in-out'
  updateCursor()
})

onUpdated(() => updateCursor())

onUnmounted(() => {})
</script>

<template>
  <Scale class="dark:fill-white dark:stroke-white" ref="svg" />
</template>

<style scoped></style>
